export default __webpack_public_path__ + "assets/e0cc42991b4011ba939aee0b9c77f24a.png";